import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

function CustomCarousel({ children = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(3.3); // default for desktop
  const intervalRef = useRef(null);

  // Adjust visibleSlides based on window width
  useEffect(() => {
    const updateVisibleSlides = () => {
      if (window.innerWidth <= 768) {
        setVisibleSlides(1.1); // 1 full + small peek for mobile
      } else {
        setVisibleSlides(3.3); // desktop view
      }
    };

    updateVisibleSlides();

    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  const maxIndex = Math.ceil(children.length - visibleSlides);

  const startAutoPlay = () => {
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 3000);
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoPlay();
    return () => {
      stopAutoPlay();
    };
  }, [visibleSlides, maxIndex]);

  const handleNext = () => {
    stopAutoPlay();
    setActiveIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const handlePrev = () => {
    stopAutoPlay();
    setActiveIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
  };

  return (
    <div className="container__slider-wrapper">
      {/* ✅ SEO Meta Tags */}
      {/* <Helmet>
        <title>Our Projects - Pravisht Digital</title>
        <meta name="description" content="Interactive and responsive carousel component for showcasing portfolio or product items." />
        <meta name="keywords" content="Projects, slider, React component, responsive, autoplay" />
        <meta name="author" content="Pravisht Projects" />
        <meta property="og:title" content="Our Projects - Pravisht Digital" />
        <meta property="og:description" content="Showcase your items in a smooth and responsive carousel using React." />
        <meta property="og:type" content="website" />
      </Helmet> */}
      <div className="container__slider" style={{ overflow: "hidden" }}>
        <button className="portfolio-prevbtn" onClick={handlePrev}>
          ‹
        </button>
        <div
          className="slider-track"
          style={{
            display: "flex",
            transition: "transform 0.8s ease-in-out",
            transform: `translateX(-${activeIndex * (100 / visibleSlides)}%)`,
            width: `${(children.length * 100) / visibleSlides}%`,
          }}
        >
          {children.map((child, index) => (
            <div
              key={index}
              style={{
                flex: `0 0 calc(100% / ${visibleSlides})`,
                boxSizing: "border-box",
                padding: "0 10px",
              }}
            >
              {child}
            </div>
          ))}
        </div>

        <button className="portfolio-nextbtn" onClick={handleNext}>
          ›
        </button>
      </div>
    </div>
  );
}

export default CustomCarousel;
